import { render, staticRenderFns } from "./ProductThumbFull.vue?vue&type=template&id=197bd9ea&lang=pug&"
import script from "./ProductThumbFull.vue?vue&type=script&lang=js&"
export * from "./ProductThumbFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports